<button [attr.type]="submit ? 'submit' : null" [ngClass]="{'inverted': inverted}" [disabled]="disabled" class="rounded-button">
    <hw-icon [icon]="icon"></hw-icon>
    <span class="label">{{ label | translate }}</span>
</button>
